import { createSelector } from "reselect";

const router = ({ router }) => router;
const query = ({ router }) => router.location.query;

export const selectRouter = createSelector([router], (router) => router);

export const selectQuery = createSelector([query], (query) => query);
